<template>
  <advanced-marker
    :options="{
      position: geoPointToLatLng(asset.location.gps!),
      title: `[${asset.key}] ${asset.description}`,
      gmpDraggable: draggableMainAsset && asset._id === mainAssetId,
      anchorTop: '-100%',
    }"
    :style="`height: ${markerIcon.scaledSize.height}px; width: ${markerIcon.scaledSize.width}px`"
    @dragend="$emit('dragend', $event)"
  >
    <template #content>
      <img :src="markerIcon.url" :width="markerIcon.scaledSize.width" :height="markerIcon.scaledSize.height" />
    </template>
  </advanced-marker>
</template>

<script setup lang="ts">
import { AdvancedMarker } from "vue3-google-map"

const {
  asset,
  mainAssetId = undefined,
  selectedAssetId = undefined,
} = defineProps<{
  draggableMainAsset?: boolean
  mainAssetId?: string
  selectedAssetId?: string
  asset: GeoAsset | LookupAsset
}>()

defineEmits<{
  (e: "dragend", event: unknown): void
}>()

const markerIcon = computed(() =>
  generateMarkerIcon({
    color: asset.category.marker.color,
    size: asset._id === mainAssetId ? MarkerSize.LARGE : asset.category.marker.size,
    highlighted: asset._id === selectedAssetId,
    label: asset.category.marker.description,
    showBadge:
      "supplierTicketStatistics" in asset
        ? !!asset.supplierTicketStatistics?.workTotal
        : "ticketCount" in asset
          ? !!asset.ticketCount?.inspection || !!asset.ticketCount?.action || !!asset.ticketCount?.malfunction
          : false,
  }),
)
</script>
